import { generateStorageKey } from '@/utils';
import { APP_TOKEN_NAME } from '@/config/constants';
import Api from '../abstract';

export let GET_LIST_MEMBERS = (params, successCallback, errorCallback) => {
    let url = `/user/members?${params.payload.query}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let GET_LIST_ALL_MEMBERS = (params, successCallback, errorCallback) => {
    let url = `/user/members?page=1&limit=1000`;

    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let DELETE_MEMBER = (params, successCallback, errorCallback) => {
    let url = `/user/members/${params.payload.id}`;
    return Api.delete(url).then(successCallback).catch(errorCallback);
};

export let UPDATE_STATUS_MEMBER = (params, successCallback, errorCallback) => {
    let url = `/user/members/${params.payload.id}`;
    let data = params.payload.data;
    return Api.patch(url, data).then(successCallback).catch(errorCallback);
};

export let CREATE_MEMBER = (params, successCallback, errorCallback) => {
    let data = params.payload.data;
    let url = data.get('id') ? `/user/members/${data.get('id')}` : `/user/members`;
    let headers = {
        Authorization: `Bearer ${window.$cookies.get(generateStorageKey(APP_TOKEN_NAME))}`,
        'content-type': 'multipart/form-data'
    };
    return Api.post(url, data, { headers }).then(successCallback).catch(errorCallback);
};

export let DETAIL_LIST_MEMBER = (params, successCallback, errorCallback) => {
    let url = `/user/members/${params.payload.id}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let GET_PROFILE_MEMBER = (params, successCallback, errorCallback) => {
    let url = `/user/profile`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let UPDATE_PROFILE_MEMBER = (params, successCallback, errorCallback) => {
    let url = `/user/profile`;
    let headers = {
        Authorization: `Bearer ${window.$cookies.get(generateStorageKey(APP_TOKEN_NAME))}`,
        'content-type': 'multipart/form-data'
    };
    let data = params.payload.data;
    return Api.post(url, data, { headers }).then(successCallback).catch(errorCallback);
};

export let RESEND_EMAIL = (params, successCallback, errorCallback) => {
    let url = `/user/members/${params.payload.id}/send-mail`;
    let data = params.payload.data;
    return Api.post(url, data).then(successCallback).catch(errorCallback);
};

export let GET_LIST_USER_CHILDREN = (params, successCallback, errorCallback) => {
    let url = `/user/link/user-children`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};
